import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  heading: {
    defaultMessage:
      'Before continuing, would you like to share some feedback on why you chose not to log in to your bank?',
    id: 'ExitFeedback.heading',
  },
  reasonOne: {
    id: 'ExitFeedback.reasonOne',
    defaultMessage: 'I did not feel secure logging into my bank through {clientName}',
  },
  reasonTwo: {
    id: 'ExitFeedback.reasonTwo',
    defaultMessage: "I wasn't prepared",
  },
  reasonThree: {
    id: 'ExitFeedback.reasonThree',
    defaultMessage: "I don't remember my credentials",
  },
  reasonFour: {
    id: 'ExitFeedback.reasonFour',
    defaultMessage: 'It felt too complicated',
  },
  reasonFive: {
    id: 'ExitFeedback.reasonFive',
    defaultMessage: "I don't have Online Banking",
  },
  feedbackLabel: {
    id: 'ExitFeedback.feedbackLabel',
    defaultMessage: 'Share feedback (optional)',
  },
  submit: {
    id: 'ExitFeedback.submit',
    defaultMessage: 'Send feedback',
  },
  skip: {
    id: 'ExitFeedback.skip',
    defaultMessage: 'Skip',
  },
  successHeading: {
    id: 'ExitFeedback.successHeading',
    defaultMessage: 'Thank you for your feedback',
  },
  initiate: {
    id: 'ExitFeedback.initiate',
    defaultMessage: 'Link your bank with an IBAN',
  },
});
